/**
 * Las pantallas de «Todas las sucursales», mirando TODOS los negocios (2026-10-03).
 *
 * Ventas, Clientes, Dinero, Por cobrar, Por pagar e Inventario de «Todos mis
 * negocios» son las MISMAS pantallas de `features/sucursales/`, dentro de
 * `AmbitoDeNegocios`: así lo que se mejore en una se ve en la otra. Ver
 * `features/sucursales/ambito.tsx`.
 *
 * Son de Premium, con la regla del consolidado: basta con que UNO de los
 * negocios del dueño lo tenga. Se pregunta una vez aquí, antes de pedir nada.
 */

import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { Cargando } from "@/components/ui";
import { reportes } from "@/lib/endpoints";
import { AmbitoDeNegocios } from "@/features/sucursales/ambito";
import { SinPremium } from "./comun";

export function EnTodosLosNegocios({ children }: { children: ReactNode }) {
  const { data, isLoading } = useQuery({
    queryKey: ["consolidado", "hoy"],
    queryFn: () => reportes.consolidado("hoy"),
    retry: false,
    staleTime: 5 * 60_000,
  });
  if (isLoading) return <Cargando />;
  if (data && !data.es_completo) return <SinPremium />;
  return <AmbitoDeNegocios>{children}</AmbitoDeNegocios>;
}
